(function () {
  'use strict';

  var DEFAULT_ALT = 'Rabitat';

  function cleanText(value) {
    return String(value || '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function filenameFromSrc(src) {
    if (!src) return '';

    try {
      var pathname = String(src).split('?')[0].split('#')[0];
      var parts = pathname.split('/');
      var file = parts[parts.length - 1] || '';
      var base = file.replace(/\.[a-z0-9]+$/i, '');
      return cleanText(base.replace(/[-_]+/g, ' '));
    } catch (error) {
      return '';
    }
  }

  function nearestHeading(img) {
    var node = img.parentElement;

    while (node && node !== document.body) {
      if (/^H[1-6]$/.test(node.tagName)) {
        return cleanText(node.textContent);
      }

      var localHeading = node.querySelector(':scope > h1, :scope > h2, :scope > h3, :scope > h4, :scope > h5, :scope > h6');
      if (localHeading) {
        return cleanText(localHeading.textContent);
      }

      node = node.parentElement;
    }

    var section = img.closest('section, main, article, [data-section-id], .shopify-section');
    if (!section) return '';

    var sectionHeading = section.querySelector('h1, h2, h3, h4, h5, h6');
    return sectionHeading ? cleanText(sectionHeading.textContent) : '';
  }

  function firstNonBlank(values) {
    for (var i = 0; i < values.length; i++) {
      var text = cleanText(values[i]);
      if (text) return text;
    }
    return '';
  }

  function getPageAltFallback() {
    return cleanText(document.documentElement.getAttribute('data-rabitat-page-alt-fallback'));
  }

  function resolveAlt(img) {
    if (!img || img.tagName !== 'IMG') return;

    if (img.getAttribute('aria-hidden') === 'true') {
      if (!img.hasAttribute('alt')) {
        img.setAttribute('alt', '');
      }
      return;
    }

    var current = img.getAttribute('alt');
    if (current != null && cleanText(current) !== '') return;

    var parentLabel = img.closest('a[aria-label], button[aria-label]');
    var resolved = firstNonBlank([
      img.getAttribute('data-alt'),
      img.getAttribute('title'),
      img.getAttribute('aria-label'),
      parentLabel ? parentLabel.getAttribute('aria-label') : '',
      getPageAltFallback(),
      nearestHeading(img),
      filenameFromSrc(img.currentSrc || img.getAttribute('src')),
      DEFAULT_ALT
    ]);

    img.setAttribute('alt', resolved || DEFAULT_ALT);
  }

  function ensureImageAlts(root) {
    if (!root) return;

    if (root.nodeType === 1 && root.tagName === 'IMG') {
      resolveAlt(root);
    }

    if (typeof root.querySelectorAll !== 'function') return;

    root.querySelectorAll('img').forEach(resolveAlt);
  }

  function getObserveRoot() {
    return document.getElementById('MainContent') || document.body || document.documentElement;
  }

  function init() {
    ensureImageAlts(getObserveRoot());
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    ensureImageAlts(event.target);
  });

  if (typeof MutationObserver !== 'undefined') {
    var pending = false;
    var observer = null;
    var mutationCount = 0;
    var maxMutations = 40;

    function disconnectObserver() {
      if (observer) {
        observer.disconnect();
        observer = null;
      }
    }

    observer = new MutationObserver(function (mutations) {
      if (pending) return;
      pending = true;

      window.requestAnimationFrame(function () {
        pending = false;
        mutationCount += 1;

        mutations.forEach(function (mutation) {
          mutation.addedNodes.forEach(function (node) {
            ensureImageAlts(node);
          });

          if (mutation.type === 'attributes' && mutation.target && mutation.target.tagName === 'IMG') {
            resolveAlt(mutation.target);
          }
        });

        if (mutationCount >= maxMutations) {
          disconnectObserver();
        }
      });
    });

    var observeRoot = getObserveRoot();
    if (observeRoot) {
      observer.observe(observeRoot, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['src', 'alt', 'data-alt', 'title']
      });
    }

    window.setTimeout(disconnectObserver, 12000);
  }

  window.RabitatImageAlt = {
    resolve: resolveAlt,
    refresh: ensureImageAlts
  };
})();
